import { Button, DrawerFooter, LoadingButton, } from '@one-thd/sui-atomic-components';
import classNames from 'classnames';
import React from 'react';
import '../../../styles/drawer.scss';
export var EditDeliveryAddressChangeFormFooter = function (_a) {
    var isLoading = _a.isLoading, isIosMobile = _a.isIosMobile, validateDeliveryAddress = _a.validateDeliveryAddress, closeDrawer = _a.closeDrawer;
    return (React.createElement(React.Fragment, null,
        React.createElement(DrawerFooter, null,
            React.createElement("div", { className: "sui-flex sui-flex-col sui-min-w-full sui-gap-2 sui-mt-8" },
                React.createElement("div", { className: "sui-mb-2" },
                    React.createElement(LoadingButton, { style: { width: '100%' }, loading: isLoading, onClick: function () { return validateDeliveryAddress(); } }, "Choose This Address")),
                React.createElement("div", { className: classNames('card-fix', {
                        'ios-bottom-fix': isIosMobile,
                    }) },
                    React.createElement(Button, { variant: "secondary", style: { width: '100%' }, onClick: function () { return closeDrawer(); } }, "Cancel"))))));
};
